import React, { useState, useEffect } from 'react';
import { FaAngleLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify'; // Import react-toastify
import 'react-toastify/dist/ReactToastify.css'; // Import toastify styles
import '../styles/changepassword.css';

function ChangePassword() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
    });
    const [errors, setErrors] = useState({}); // State for validation errors
    const [username, setUsername] = useState(''); // State for username from localStorage

    // Fetch username from localStorage on component mount
    useEffect(() => {
        try {
            const storedUser = localStorage.getItem("user");
            if (storedUser) {
                const user = JSON.parse(storedUser);
                setUsername(user.username || '');
            } else {
                setErrors({ general: "No user data found in localStorage." });
            }
        } catch (error) {
            console.error("Error retrieving user data:", error);
            setErrors({ general: "Failed to retrieve user data: " + error.message });
        }
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });

        // Real-time validation
        const newErrors = { ...errors };
        if (name === 'newPassword' || name === 'confirmPassword') {
            if (value && !/^[A-Z]/.test(value)) {
                newErrors.newPassword = 'New password must start with a capital letter.';
            } else if (name === 'newPassword' && formData.confirmPassword && value !== formData.confirmPassword) {
                newErrors.confirmPassword = 'Passwords must match.';
            } else if (name === 'confirmPassword' && formData.newPassword && value !== formData.newPassword) {
                newErrors.confirmPassword = 'Passwords must match.';
            } else {
                delete newErrors.newPassword;
                delete newErrors.confirmPassword;
            }
        }
        setErrors(newErrors);
    };

    const handleBack = () => {
        navigate('/dashboard'); // Go back to dashboard
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Final validation before submission
        const newErrors = {};
        if (!formData.oldPassword) newErrors.oldPassword = "Old password is required.";
        if (!formData.newPassword) newErrors.newPassword = "New password is required.";
        if (!/^[A-Z]/.test(formData.newPassword)) newErrors.newPassword = "New password must start with a capital letter.";
        if (formData.newPassword !== formData.confirmPassword) {
            newErrors.confirmPassword = "Passwords must match.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return; // Don't proceed with submission
        }

        // API call to update password
        try {
            if (!username) {
                throw new Error("Username not found.");
            }
            const baseUrl = process.env.REACT_APP_API_BASE_URL;
            const response = await fetch(`${baseUrl}/users/password/${username}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`, // Include token if required
                },
                body: JSON.stringify({
                    oldpassword: formData.oldPassword,
                    newPassword: formData.newPassword,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            console.log('Password updated successfully:', result);
            toast.success("Password updated successfully!", {
                position: "top-right",
                autoClose: 3000,
                closeButton: false, // No close button
            });
            navigate('/'); // Navigate back on success
        } catch (error) {
            console.error('Error updating password:', error.message);
            if (error.message === 'Old password is incorrect.') {
                toast.error("Old password is incorrect.", {
                    position: "top-right",
                    autoClose: 3000,
                    closeButton: false, // No close button
                });
            } else {
                toast.error(error.message || "Failed to update password.", {
                    position: "top-right",
                    autoClose: 3000,
                    closeButton: false, // No close button
                });
            }
            setErrors({ submit: error.message || "Failed to update password" });
        }
    };

    return (
        <div className="Password-page">
            <ToastContainer /> {/* Add ToastContainer for alerts */}
            <div className="Password-content">
                <div className="password-card">
                    <form onSubmit={handleSubmit}>
                        <div className={`form-field ${errors.oldPassword || errors.submit ? 'error' : ''}`}>
                            <label>Old Password</label>
                            <input
                                type="password"
                                name="oldPassword"
                                value={formData.oldPassword}
                                onChange={handleInputChange}
                                placeholder="Enter old password"
                            />
                            {errors.oldPassword && <p className="error-message">{errors.oldPassword}</p>}
                            {errors.submit && errors.submit === "Old password is incorrect." && <p className="error-message">{errors.submit}</p>}
                        </div>
                        <div className={`form-field ${errors.newPassword ? 'error' : ''}`}>
                            <label>New Password</label>
                            <input
                                type="password"
                                name="newPassword"
                                value={formData.newPassword}
                                onChange={handleInputChange}
                                placeholder="Enter new password"
                            />
                            {errors.newPassword && <p className="error-message">{errors.newPassword}</p>}
                        </div>
                        <div className={`form-field ${errors.confirmPassword ? 'error' : ''}`}>
                            <label>Confirm new password</label>
                            <input
                                type="password"
                                name="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleInputChange}
                                placeholder="Enter confirm password"
                            />
                            {errors.confirmPassword && <p className="error-message">{errors.confirmPassword}</p>}
                        </div>
                        <button type="submit" className="confirm-reset-button">
                            <FaAngleLeft className="confirm-arrow" /> CONFIRM RESET
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ChangePassword;